module.exports = __webpack_public_path__ + "static/assets/860b1fb201c1d7ca0e163e09c622054b.svg";